import { CIcon } from '~/icons/types'

export const ciGearboxManual: CIcon = {
  width: '42',
  height: '42',
  paths: [
    {
      d:
        'M37.642.16a3.946 3.946 0 0 0-3.764 3.715A3.926 3.926 0 0 0 36.54 7.8v11.155c0 .421-.34.77-.769.77H22.27V7.808a3.942 3.942 0 0 0 2.663-3.926A3.953 3.953 0 0 0 21.169.159a3.932 3.932 0 0 0-4.088 3.926 3.948 3.948 0 0 0 2.663 3.724v11.924H5.48V7.81a3.942 3.942 0 0 0 2.664-3.926A3.954 3.954 0 0 0 4.37.159 3.938 3.938 0 0 0 .283 4.093a3.948 3.948 0 0 0 2.663 3.724v26.374a3.945 3.945 0 0 0-2.663 3.934c.105 2.016 1.757 3.635 3.764 3.716a3.932 3.932 0 0 0 4.088-3.926 3.948 3.948 0 0 0-2.663-3.724V22.267h14.264v11.924a3.945 3.945 0 0 0-2.663 3.934 3.94 3.94 0 0 0 3.764 3.716 3.932 3.932 0 0 0 4.088-3.926 3.948 3.948 0 0 0-2.664-3.724V22.267h14.483a2.315 2.315 0 0 0 2.315-2.315V7.809a3.94 3.94 0 0 0 2.663-3.724A3.925 3.925 0 0 0 37.642.16ZM35.075 41.679h-2.469V31.066c0-.396.316-.712.713-.712h4.654c.519 0 .988.089 1.41.259.42.17.784.42 1.076.736.3.316.526.705.688 1.142.162.445.243.939.243 1.473 0 .77-.17 1.441-.51 2.016-.34.575-.858.988-1.547 1.247l2.227 4.444h-2.745l-1.975-4.153h-1.765v4.16Zm2.599-6.233c.364 0 .656-.097.866-.284.21-.186.316-.47.316-.834v-.712c0-.364-.105-.648-.316-.834-.21-.186-.502-.283-.866-.283h-2.29a.307.307 0 0 0-.309.308v2.647h2.599v-.008Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'gearbox-manual',
  type: 'regular'
}
